import type { FC } from 'react';
import { cn } from 'src/utils/cn';

export const CheckedIcon: FC<{
  error?: boolean;
  disabled?: boolean;
}> = ({ error, disabled }) => {
  const errorColor = 'var(--color-border-support-error-subdued)';
  const disabledColor = 'var(--color-border-surface-disabled)';
  const disabledBgColor = 'var(--color-background-surface-disabled)';
  const regularColor = 'var(--color-border-surface-default)';

  const primaryColor = disabled
    ? disabledColor
    : error
      ? errorColor
      : regularColor;
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 14 14"
      className={cn(disabled ? 'cursor-not-allowed' : 'cursor-pointer')}
    >
      <rect
        x="0.5"
        y="0.5"
        width="13"
        height="13"
        rx="2.5"
        fill={primaryColor}
        stroke={primaryColor}
        strokeWidth="1"
      />
      <path
        d="M3 6.5 L6.045 9.545 L11.065 4.525"
        fill="none"
        stroke={disabled ? disabledBgColor : '#fff'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UncheckedIcon: FC<{
  error?: boolean;
  disabled?: boolean;
}> = ({ error, disabled }) => {
  const errorColor = 'var(--color-border-support-error-subdued)';
  const errorBgColor = 'var(--color-background-support-error-minimal)';
  const disabledColor = 'var(--color-border-surface-disabled)';
  const disabledBgColor = 'var(--color-background-surface-disabled)';
  const regularColor = 'var(--color-border-surface-default)';

  const primaryColor = disabled
    ? disabledColor
    : error
      ? errorColor
      : regularColor;
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 14 14"
      className={cn(disabled ? 'cursor-not-allowed' : 'cursor-pointer')}
    >
      <rect
        x="0.5"
        y="0.5"
        width="13"
        height="13"
        rx="2.5"
        fill={disabled ? disabledBgColor : error ? errorBgColor : '#fff'}
        stroke={primaryColor}
        strokeWidth="1"
      />
    </svg>
  );
};

export const MixedCheck: FC<{
  error?: boolean;
  disabled?: boolean;
}> = ({ error, disabled }) => {
  const errorColor = 'var(--color-border-support-error-subdued)';
  const disabledColor = 'var(--color-border-surface-disabled)';
  const regularColor = 'var(--color-border-surface-default)';

  const primaryColor = disabled
    ? disabledColor
    : error
      ? errorColor
      : regularColor;
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 14 14"
      className={cn(disabled ? 'cursor-not-allowed' : 'cursor-pointer')}
    >
      <rect
        x="0.5"
        y="0.5"
        width="13"
        height="13"
        rx="2.5"
        fill={primaryColor}
        stroke={primaryColor}
        strokeWidth="1"
      />
      <path
        d="M3.319 6.934 H11.061"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
